import React from 'react';
import { Spinner, SpinnerSize } from '@fluentui/react/lib/Spinner';
import { Container } from './styled';


export const FullScreenLoadingSpinner = () => {
    return (
        <Container>
            <Spinner size={SpinnerSize.large} />
        </Container>
    )
}